import { kuiperClassNames } from '@opallabs/kuiper'
import { WorkflowIcon } from '@opallabs/lapidary'
import { statuses, Statuses } from './statuses/statuses'

import './styles.scss'

type MomentWorkflowStatusProps = {
  classNames?: string[]
  workflowStatus: Statuses
}

const MomentWorkflowStatus = ({
  classNames = [],
  workflowStatus,
}: MomentWorkflowStatusProps) => {
  if (workflowStatus === 'notCreated') {
    return null
  }

  const status = statuses[workflowStatus]
  const icon = status.icon

  return (
    <div
      className={kuiperClassNames('momentCard-workflowStatus', ...classNames)}
    >
      <span className={kuiperClassNames('workflowText')}>
        <p>{statuses[workflowStatus].string}</p>
      </span>
      <span className={kuiperClassNames('workflowIcon')}>
        <WorkflowIcon status={icon} />
      </span>
    </div>
  )
}

export default MomentWorkflowStatus
